import { Button } from "@voicerun/design-system";
import clsx from "clsx";

import { Icon } from "./Icon";
import { Spinner } from "./Spinner";

type IconButtonProps = {
  icon: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  variant?: "brand" | "secondary" | "danger" | "info" | "transparent";
  title?: string;
  className?: string;
};

export const IconButton = ({ icon, onClick = () => {}, isDisabled = false, isLoading = false, className = "", variant = "brand", title }: IconButtonProps) => {
  return (
    <Button
      onClick={!isLoading ? onClick : undefined}
      isDisabled={isDisabled || isLoading}
      className={clsx(
        "!h-9 !w-9 !min-w-9 !min-h-9 !max-w-9 !max-h-9 !rounded-full !p-0",
        variant === "brand" && "!bg-brand hover:!bg-brand/80",
        variant === "secondary" && "!bg-transparent hover:!bg-brand/20",
        variant === "danger" && "!bg-transparent hover:!bg-red-500/20",
        variant === "info" && "!bg-transparent hover:!bg-gray-200 dark:hover:!bg-gray-700",
        variant === "transparent" && "!bg-transparent",
        className,
      )}
      title={title}
    >
      {isLoading ? (
        <Spinner
          className={clsx(
            variant === "brand" && "!text-white",
            variant === "secondary" && "!text-brand",
            variant === "danger" && "!text-red-500",
            variant === "info" && "!text-gray-500 dark:!text-gray-400",
            variant === "transparent" && "!text-gray-500 dark:!text-gray-400",
          )}
          size={14}
          variant="brand"
        />
      ) : (
        <Icon
          name={icon}
          size={16}
          className={clsx(
            variant === "brand" && "!text-white",
            variant === "secondary" && "!text-brand",
            variant === "danger" && "!text-red-500",
            variant === "info" && "!text-gray-500 dark:!text-gray-400",
            variant === "transparent" && "!text-gray-500 dark:!text-gray-400",
          )}
        />
      )}
    </Button>
  );
};
